export default {
  resendTimeoutDelay: 10000,
};
